import { useSelector, useDispatch } from 'react-redux';
import lobbyMachinesSlice from './lobbyMachinesSlice';

function useLlobbyMachines() {
    const { lobbyMachines } = useSelector((state) => {
        return state.lobbyMachines;
    });
    const dispatch = useDispatch();
  
    function setLobbyMachines(lobbyMachines) {
      dispatch(lobbyMachinesSlice.actions.setLobbyMachines(lobbyMachines));
    }
  
    return { lobbyMachines, setLobbyMachines };
}

export default useLlobbyMachines;